// extracted by mini-css-extract-plugin
export default {"title":"BottomPage_title__b7e2m","text":"BottomPage_text__E6QQj"};